import { fromJSON, IQuoteSheet, IQuoteSheetJSON, toJSON } from 'features/BookingFlow'
import { Resource, Serializer } from 'service/Resource'

export interface ManualQuotesListEndpoint extends Resource<IQuoteSheetJSON, IQuoteSheet> {}

export const createManualQuotesListEndpoint = (http) => {
  const serializer: Serializer<IQuoteSheetJSON, IQuoteSheet> = {
    fromJSON,
    toJSON,
  }
  return new Resource<IQuoteSheetJSON, IQuoteSheet>('v1/quotes/manualQuotes', http, serializer)
}
